/**
 * В данном файле хранится весь функционал для аналитики Detectum
 * ФУНКЦИИ ИЗ ФАЙЛА НЕ ПЕРЕИСПОЛЬЗОВАТЬ
 * нужна была кастомная логика для присвоения значения default
 * те если пользователь не посещал на нашем сайте поиск или эксплор, то значение должно быть отправлено default
 * @see https://tracker.yandex.ru/LT-38432
 *
 * Описание сценария работы данного функционала:
 * 1. Если пользователь не посещал страницу поиска, то ему будет присвоенна группа default
 * 2. Если пользователь посещал страницу поиска, то ему выдастся одна из четырех групп detectum_1, detectum_2, recommender_1, recommender_2
 * 3. Если разработчик задал себе группу через урл у него будет уходить в аналитику значение: developer
 * 4. Для того чтобы бэк понимал какой вариант рекомендатора использовать применяется функция getGroupABDetectum. Бэк принимет либо detectum либо hotelrank
 *
 * Есть функционал для того, чтобы тебе присвоился режим разработчика для этого нужно к url добавить следующую query:
 ** Ключ query: ab_detectum_group
 ** Значение для присвоения группы detectum: detectum
 ** Значение для присвоения группы recommender: recommender
 ** Значение для возвращения в обычный флон: reset
 *
 * Для значений detectum и recommender в аналитику будет уходить значение developer
 * Чтобы стать обычным пользователем (не developer) нужно передать значение reset
 *
 * Пример URL для присвоения группы detectum:
 * @example http://example.com/?ab_detectum_group=detectum
 *
 * Пример URL для присвоения группы reccommender:
 * @example http://example.com/?ab_detectum_group=reccommender
 *
 * Пример URL для выхода из режима разработчика:
 * @example http://example.com/?ab_detectum_group=reset
 */
import { isSSR } from 'src/helpers/ssr';
import { getFlagSigmaOptionByName } from '..';

// ключ по которому можно захордкодить группу для AA/BB
const AB_DETECTUM_GROUP = 'ab_detectum_group';
// принудительная группа detectum
const DETECTUM_GROUP = 'detectum';
// принудительная группа recommender
const RECOMMENDER_GROUP = 'recommender';
// принудительная группа default
const RESET_GROUP = 'reset';

const parseUrlDetectumGroup = ():
  | 'detectum'
  | 'recommender'
  | 'reset'
  | null => {
  try {
    const url = new URL(window.location.href);
    const value = url.searchParams.get(AB_DETECTUM_GROUP);

    if (value === DETECTUM_GROUP) {
      return 'detectum';
    }

    if (value === RECOMMENDER_GROUP) {
      return 'recommender';
    }

    if (value === RESET_GROUP) {
      return 'reset';
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
  return null;
};

const saveLocalStorageDetectumGroup = (
  value: 'detectum' | 'recommender' | 'reset',
): void => {
  try {
    if (value === 'reset') {
      localStorage.removeItem(AB_DETECTUM_GROUP);
      return;
    }

    localStorage.setItem(AB_DETECTUM_GROUP, value);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};

const getLocalStorageDetectumGroup = (): 'detectum' | 'recommender' | null => {
  try {
    const value = localStorage.getItem(AB_DETECTUM_GROUP);

    if (value === DETECTUM_GROUP) {
      return 'detectum';
    }

    if (value === RECOMMENDER_GROUP) {
      return 'recommender';
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }

  return null;
};

const DETECTUM_KEY_LOCAL_STORAGE = 'lt-visited-search-v2';
const DETECTUM_VALUE_LOCAL_STORAGE = 'visit';

/**
 * Функция возвращает группу для ggh, чтобы бэк понимал какой рекомендатор использовать detectum или наш рекомендатор
 * @deprecated использовать НЕЛЬЗЯ это для AB
 */
export const getGroupABDetectum = async (): Promise<
  'detectum' | 'hotelrank'
> => {
  // если в url есть группа то возвращаем ее и сохраняем в локал сторадже
  const urlValue = parseUrlDetectumGroup();
  if (urlValue) {
    saveLocalStorageDetectumGroup(urlValue);
  }
  if (urlValue === 'detectum') {
    return 'detectum';
  }
  if (urlValue === 'recommender') {
    return 'hotelrank';
  }

  // если в локал сторадже есть группа то возвращаем ее
  const localStorageValue = getLocalStorageDetectumGroup();
  if (localStorageValue === 'detectum') {
    return 'detectum';
  }
  if (localStorageValue === 'recommender') {
    return 'hotelrank';
  }

  const value = await getFlagSigmaOptionByName('abDetectum');

  if (value === 'detectum_1' || value === 'detectum_2') {
    return 'detectum';
  }

  return 'hotelrank';
};

/**
 * Использовать данную функцию для аналитики на страницах:
 * Search и SeoPage
 * @deprecated использовать НЕЛЬЗЯ это для AB
 */
export const getValueForExperimentDetectumVsRecommenderSearchPages =
  async (): Promise<
    | 'default'
    | 'detectum_1'
    | 'detectum_2'
    | 'recommender_1'
    | 'recommender_2'
    | 'developer'
  > => {
    if (isSSR) {
      return 'default';
    }

    // если группа назначена через url в аналитику будет уходить developer
    const urlValue = parseUrlDetectumGroup();
    if (urlValue) {
      saveLocalStorageDetectumGroup(urlValue);
    }
    const localStorageValue = getLocalStorageDetectumGroup();
    if (
      urlValue === 'detectum' ||
      localStorageValue === 'detectum' ||
      urlValue === 'recommender' ||
      localStorageValue === 'recommender'
    ) {
      return 'developer';
    }

    const abDetectumValue = await getFlagSigmaOptionByName('abDetectum');

    localStorage.setItem(
      DETECTUM_KEY_LOCAL_STORAGE,
      DETECTUM_VALUE_LOCAL_STORAGE,
    );

    if (abDetectumValue === undefined) {
      return 'default';
    }

    if (abDetectumValue === 'detectum_1') {
      return 'detectum_1';
    }

    if (abDetectumValue === 'detectum_2') {
      return 'detectum_2';
    }

    if (abDetectumValue === 'recommender_1') {
      return 'recommender_1';
    }

    if (abDetectumValue === 'recommender_2') {
      return 'recommender_2';
    }

    return 'default';
  };

/**
 * Использовать данную функцию для аналитики на остальных страницах
 * @deprecated использовать НЕЛЬЗЯ это для AB
 */
export const getValueForExperimentDetectumVsRecommenderOtherPages =
  async (): Promise<
    | 'default'
    | 'detectum_1'
    | 'detectum_2'
    | 'recommender_1'
    | 'recommender_2'
    | 'developer'
  > => {
    if (isSSR) {
      return 'default';
    }

    // если группа назначена через url в аналитику будет уходить developer
    const urlValue = parseUrlDetectumGroup();
    if (urlValue) {
      saveLocalStorageDetectumGroup(urlValue);
    }
    const localStorageValue = getLocalStorageDetectumGroup();
    if (
      urlValue === 'detectum' ||
      localStorageValue === 'detectum' ||
      urlValue === 'recommender' ||
      localStorageValue === 'recommender'
    ) {
      return 'developer';
    }

    const abDetectumValue = await getFlagSigmaOptionByName('abDetectum');
    const isSearchVisited =
      localStorage.getItem(DETECTUM_KEY_LOCAL_STORAGE) ===
      DETECTUM_VALUE_LOCAL_STORAGE;
    if (abDetectumValue === undefined || !isSearchVisited) {
      return 'default';
    }

    if (abDetectumValue === 'detectum_1') {
      return 'detectum_1';
    }

    if (abDetectumValue === 'detectum_2') {
      return 'detectum_2';
    }

    if (abDetectumValue === 'recommender_1') {
      return 'recommender_1';
    }

    if (abDetectumValue === 'recommender_2') {
      return 'recommender_2';
    }

    return 'default';
  };
